import PageHero from "@/components/layout/PageHero";
import ThreeForces from "@/components/sections/ThreeForces";
import Timeline from "@/components/sections/Timeline";
import IntelligenceOverlay from "@/components/sections/IntelligenceOverlay";
import Regulation from "@/components/sections/Regulation";
import Marquee from "@/components/sections/Marquee";
import CTA from "@/components/sections/CTA";
import { IMAGES } from "@/lib/constants";

export default function WhyCarbonis() {
    return (
        <div data-testid="page-why-carbonis">
            <PageHero
                title={<>Because emissions are already <em className="text-gold not-italic font-light">a P&amp;L question.</em></>}
                lead="Regulation, procurement, and lenders are rewriting the cost of capital in real time. Carbonis exists because the balance-sheet consequence has arrived before the operating layer to manage it — and reporting tools cannot close that gap."
                image={IMAGES.factory}
            />
            <ThreeForces />
            <Timeline />
            <IntelligenceOverlay />
            <Marquee />
            <Regulation />
            <CTA />
        </div>
    );
}
